/** 金融人才问卷字段选项与中文标签 */

export const FINANCE_SURVEY_LABELS = {
  survey_name: '姓名',
  region: '所在地区',
  contact_phone: '联系方式-手机号',
  wechat_id: '联系方式-微信号',
  douyin_nickname: '抖音昵称',
  douyin_account_id: '抖音账号ID',
  fan_count: '当前粉丝量级',
  finance_qualifications: '金融资质',
  finance_qualification_other: '金融资质-其他',
  institution: '目前所属机构',
  institution_other: '目前所属机构-其他',
  work_years: '金融从业年限',
  violation_history: '账号历史违规',
  violation_history_other: '账号历史违规-其他',
  live_platforms: '主要直播平台',
  live_platform_other: '主要直播平台-其他',
  live_experience: '直播经验',
  content_tracks: '核心内容赛道',
  content_track_other: '核心内容赛道-其他',
  career_motivation: '从业动机',
  association_expectation: '期望协会在金融人才职业发展上',
  association_expectation_other: '期望协会支持-其他',
  location_preference: '对于成都自媒体协会提供的金融岗位地域上',
  honor_expectation: '除了金融自媒体人职业发展外还希望协会提供',
  research_activity: '上市公司调研/企业走访活动',
  social_voice: '是否愿意为社会发声',
  compliance_commitment: '是否愿意遵守金融行业合规性与廉洁性？成为积极正向的金融自媒体人',
  extra_support: '综上以外，还期望成都自媒体协会提供哪些帮助和支持',
}

export const FAN_COUNT_OPTIONS = ['<1w', '1-5w', '5-10w', '10-30w', '30w+']

export const FINANCE_QUALIFICATION_OPTIONS = [
  '证券从业资格证',
  '投资顾问资格证',
  '基金从业资格证',
  '期货从业资格证',
  'CFA（金融特许分析师）',
  '其他',
]

export const INSTITUTION_OPTIONS = ['券商公司', '投顾公司', '其他']

export const WORK_YEARS_OPTIONS = ['1-3年', '3-5年', '5-10年', '10年+']

export const VIOLATION_OPTIONS = ['无任何违规', '警告1-2次', '限流/短期封禁', '功能封禁/处罚中', '其他']

export const LIVE_PLATFORM_OPTIONS = ['抖音', '视频号', '小红书', '其他']

export const LIVE_EXPERIENCE_OPTIONS = ['从未开播', '新手<10场', '有经验10-50场', '成熟>50场']

export const CONTENT_TRACK_OPTIONS = [
  '行情解读与预判',
  '政策/宏观分析',
  '投资心态/风控技巧',
  '小白理财科普',
  '战法思路(合规版)',
  '其他',
]

export const CAREER_MOTIVATION_OPTIONS = ['热爱财经', '职业发展', '变现增收', 'IP打造']

export const ASSOCIATION_EXPECTATION_OPTIONS = [
  '提供优质就业岗位',
  '提供优质择业选择',
  '提供更好专业支持',
  '提供行业合规培训',
  '提供专业自媒体运营支持',
  '其他',
]

export const LOCATION_PREFERENCE_OPTIONS = ['北京', '上海', '广州', '深圳', '成都', '杭州', '其他']

export const HONOR_EXPECTATION_OPTIONS = ['能给予一定荣誉称号', '不需要，只想提高收入']

export const RESEARCH_ACTIVITY_OPTIONS = ['有机会很想参与', '不感兴趣']

export const YES_NO_OPTIONS = ['愿意', '不愿意']

/** 问卷字段校验顺序（用于进度与动态提示） */
export const FINANCE_SURVEY_FIELD_ORDER = [
  'survey_name',
  'region_area',
  'region_detail',
  'contact_phone',
  'wechat_id',
  'douyin_nickname',
  'douyin_account_id',
  'fan_count',
  'finance_qualifications',
  'finance_qualification_other',
  'institution',
  'institution_other',
  'work_years',
  'violation_history',
  'violation_history_other',
  'live_platforms',
  'live_platform_other',
  'live_experience',
  'content_tracks',
  'content_track_other',
  'career_motivation',
  'association_expectation',
  'association_expectation_other',
  'location_preference',
  'honor_expectation',
  'research_activity',
  'social_voice',
  'compliance_commitment',
  'extra_support',
]

const FIELD_HINT_MESSAGES = {
  survey_name: '请填写姓名',
  region_area: '请选择省 / 市 / 区',
  region_detail: '请填写街道、门牌号等详细地址',
  contact_phone: '请填写手机号',
  wechat_id: '请填写微信号',
  douyin_nickname: '请填写抖音昵称',
  douyin_account_id: '请填写抖音账号 ID',
  fan_count: '请选择当前粉丝量级',
  finance_qualifications: '请选择金融资质',
  finance_qualification_other: '请填写其他金融资质说明',
  institution: '请选择目前所属机构',
  institution_other: '请填写机构名称',
  work_years: '请选择金融从业年限',
  violation_history: '请选择账号历史违规情况',
  live_platforms: '请选择主要直播平台',
  live_platform_other: '请填写其他直播平台',
  live_experience: '请选择直播经验',
  content_tracks: '请选择核心内容赛道',
  content_track_other: '请填写其他内容赛道',
  career_motivation: '请选择从业动机',
  association_expectation: '请选择期望协会提供的支持',
  association_expectation_other: '请填写其他期望说明',
  location_preference: '请选择金融岗位地域偏好',
  honor_expectation: '请选择除职业发展外还希望协会提供的内容',
  research_activity: '请选择对调研/走访活动的态度',
  social_voice: '请选择是否愿意为社会发声',
  compliance_commitment: '请选择是否愿意遵守合规与廉洁',
  extra_support: '请填写还期望协会提供的帮助和支持',
}

export function formatRegionAreaText(province, city, county) {
  const parts = []
  const p = String((province && province.name) || '').trim()
  const c = String((city && city.name) || '').trim()
  const d = String((county && county.name) || '').trim()
  if (p) parts.push(p)
  if (c && c !== p) parts.push(c)
  if (d) parts.push(d)
  return parts.join('')
}

export function composeRegionText(form) {
  const f = form || {}
  const area = String(f.region_area_text || '').trim()
  const detail = String(f.region_detail || '').trim()
  if (!area && !detail) return ''
  if (!detail) return area
  if (!area) return detail
  return `${area}${detail}`
}

function isFieldRequired(field, form) {
  const f = form || {}
  if (field === 'finance_qualification_other') {
    return Array.isArray(f.finance_qualifications) && f.finance_qualifications.includes('其他')
  }
  if (field === 'institution_other') return f.institution === '其他'
  if (field === 'violation_history_other') return f.violation_history === '其他'
  if (field === 'live_platform_other') {
    return Array.isArray(f.live_platforms) && f.live_platforms.includes('其他')
  }
  if (field === 'content_track_other') {
    return Array.isArray(f.content_tracks) && f.content_tracks.includes('其他')
  }
  if (field === 'association_expectation_other') return f.association_expectation === '其他'
  return true
}

export function isFinanceSurveyFieldFilled(field, form) {
  const f = form || {}
  if (!isFieldRequired(field, f)) return true

  switch (field) {
    case 'region_area':
      return Array.isArray(f.region_codes) && f.region_codes.length === 3 && !!String(f.region_area_text || '').trim()
    case 'finance_qualifications':
    case 'live_platforms':
    case 'content_tracks':
      return Array.isArray(f[field]) && f[field].length > 0
    default:
      return !!String(f[field] || '').trim()
  }
}

export function getFinanceSurveyPendingHints(form) {
  const hints = {}
  FINANCE_SURVEY_FIELD_ORDER.forEach((field) => {
    if (!isFieldRequired(field, form)) return
    if (!isFinanceSurveyFieldFilled(field, form)) {
      hints[field] = FIELD_HINT_MESSAGES[field] || '请完善此项'
    }
  })
  return hints
}

export function getFinanceSurveyProgress(form) {
  const required = FINANCE_SURVEY_FIELD_ORDER.filter((field) => isFieldRequired(field, form))
  const filled = required.filter((field) => isFinanceSurveyFieldFilled(field, form)).length
  const pending = required.filter((field) => !isFinanceSurveyFieldFilled(field, form))
  return {
    filled,
    total: required.length,
    percent: required.length ? Math.round((filled / required.length) * 100) : 100,
    pending,
  }
}

export function emptyFinanceSurvey() {
  return {
    survey_name: '',
    region: '',
    region_codes: [],
    region_area_text: '',
    region_detail: '',
    contact_phone: '',
    wechat_id: '',
    douyin_nickname: '',
    douyin_account_id: '',
    fan_count: '',
    finance_qualifications: [],
    finance_qualification_other: '',
    institution: '',
    institution_other: '',
    work_years: '',
    violation_history: '',
    violation_history_other: '',
    live_platforms: [],
    live_platform_other: '',
    live_experience: '',
    content_tracks: [],
    content_track_other: '',
    career_motivation: '',
    association_expectation: '',
    association_expectation_other: '',
    location_preference: '',
    honor_expectation: '',
    research_activity: '',
    social_voice: '',
    compliance_commitment: '',
    extra_support: '',
  }
}

export function validateFinanceSurvey(form) {
  const f = form || {}
  const fail = (field, message) => ({ field, message })

  const req = (v, field, msg) => {
    if (!String(v || '').trim()) return fail(field, msg)
    return null
  }

  const checks = [
    req(f.survey_name, 'survey_name', '请填写姓名'),
    !Array.isArray(f.region_codes) || f.region_codes.length !== 3 || !String(f.region_area_text || '').trim()
      ? fail('region_area', '请选择省 / 市 / 区')
      : null,
    req(f.region_detail, 'region_detail', '请填写详细地址（街道、门牌号等）'),
    req(f.contact_phone, 'contact_phone', '请填写联系方式中的手机号'),
    req(f.wechat_id, 'wechat_id', '请填写微信号'),
    req(f.douyin_nickname, 'douyin_nickname', '请填写抖音昵称'),
    req(f.douyin_account_id, 'douyin_account_id', '请填写抖音账号ID'),
    req(f.fan_count, 'fan_count', '请选择当前粉丝量级'),
    !Array.isArray(f.finance_qualifications) || !f.finance_qualifications.length
      ? fail('finance_qualifications', '请选择金融资质')
      : null,
    f.finance_qualifications && f.finance_qualifications.includes('其他') && !String(f.finance_qualification_other || '').trim()
      ? fail('finance_qualification_other', '请填写金融资质-其他说明')
      : null,
    req(f.institution, 'institution', '请选择目前所属机构'),
    f.institution === '其他' && !String(f.institution_other || '').trim()
      ? fail('institution_other', '请填写目前所属机构-其他说明')
      : null,
    req(f.work_years, 'work_years', '请选择金融从业年限'),
    req(f.violation_history, 'violation_history', '请选择账号历史违规情况'),
    f.violation_history === '其他' && !String(f.violation_history_other || '').trim()
      ? fail('violation_history_other', '请填写账号历史违规-其他说明')
      : null,
    !Array.isArray(f.live_platforms) || !f.live_platforms.length
      ? fail('live_platforms', '请选择主要直播平台')
      : null,
    f.live_platforms && f.live_platforms.includes('其他') && !String(f.live_platform_other || '').trim()
      ? fail('live_platform_other', '请填写主要直播平台-其他说明')
      : null,
    req(f.live_experience, 'live_experience', '请选择直播经验'),
    !Array.isArray(f.content_tracks) || !f.content_tracks.length
      ? fail('content_tracks', '请选择核心内容赛道')
      : null,
    f.content_tracks && f.content_tracks.includes('其他') && !String(f.content_track_other || '').trim()
      ? fail('content_track_other', '请填写核心内容赛道-其他说明')
      : null,
    req(f.career_motivation, 'career_motivation', '请选择从业动机'),
    req(f.association_expectation, 'association_expectation', '请选择期望协会提供的支持'),
    f.association_expectation === '其他' && !String(f.association_expectation_other || '').trim()
      ? fail('association_expectation_other', '请填写期望协会支持-其他说明')
      : null,
    req(f.location_preference, 'location_preference', '请选择金融岗位地域偏好'),
    req(f.honor_expectation, 'honor_expectation', '请选择除职业发展外还希望协会提供的内容'),
    req(f.research_activity, 'research_activity', '请选择对调研/走访活动的态度'),
    req(f.social_voice, 'social_voice', '请选择是否愿意为社会发声'),
    req(f.compliance_commitment, 'compliance_commitment', '请选择是否愿意遵守合规与廉洁'),
    req(f.extra_support, 'extra_support', '请填写还期望协会提供的帮助和支持'),
  ]
  const phone = String(f.contact_phone || '').trim()
  if (phone && !/^1[3-9]\d{9}$/.test(phone)) {
    checks.push(fail('contact_phone', '联系方式中的手机号格式不正确'))
  }
  for (let i = 0; i < checks.length; i++) {
    if (checks[i]) return checks[i]
  }
  return null
}

export function normalizeFinanceSurvey(form) {
  const f = form || {}
  const trim = (v) => String(v || '').trim()
  const arr = (v) => (Array.isArray(v) ? v.map((x) => trim(x)).filter(Boolean) : [])
  return {
    survey_name: trim(f.survey_name),
    region: composeRegionText(f),
    contact_phone: trim(f.contact_phone),
    wechat_id: trim(f.wechat_id),
    douyin_nickname: trim(f.douyin_nickname),
    douyin_account_id: trim(f.douyin_account_id),
    fan_count: trim(f.fan_count),
    finance_qualifications: arr(f.finance_qualifications),
    finance_qualification_other: trim(f.finance_qualification_other),
    institution: trim(f.institution),
    institution_other: trim(f.institution_other),
    work_years: trim(f.work_years),
    violation_history: trim(f.violation_history),
    violation_history_other: trim(f.violation_history_other),
    live_platforms: arr(f.live_platforms),
    live_platform_other: trim(f.live_platform_other),
    live_experience: trim(f.live_experience),
    content_tracks: arr(f.content_tracks),
    content_track_other: trim(f.content_track_other),
    career_motivation: trim(f.career_motivation),
    association_expectation: trim(f.association_expectation),
    association_expectation_other: trim(f.association_expectation_other),
    location_preference: trim(f.location_preference),
    honor_expectation: trim(f.honor_expectation),
    research_activity: trim(f.research_activity),
    social_voice: trim(f.social_voice),
    compliance_commitment: trim(f.compliance_commitment),
    extra_support: trim(f.extra_support),
  }
}

/** 展示时隐藏：已合并进主字段的「其他」说明与地区拆分字段 */
export const FINANCE_SURVEY_DISPLAY_HIDDEN_KEYS = [
  'region_area_text',
  'region_detail',
  'region_codes',
  'finance_qualification_other',
  'institution_other',
  'violation_history_other',
  'live_platform_other',
  'content_track_other',
  'association_expectation_other',
]

function mergeSurveySingleOther(mainVal, otherVal) {
  const main = String(mainVal || '').trim()
  const other = String(otherVal || '').trim()
  if (main === '其他' && other) return `其他 ${other}`
  return main
}

function mergeSurveyArrayOther(arrVal, otherVal) {
  const other = String(otherVal || '').trim()
  if (!Array.isArray(arrVal)) return []
  return arrVal
    .map((x) => String(x || '').trim())
    .filter(Boolean)
    .map((item) => (item === '其他' && other ? `其他 ${other}` : item))
}

/** 后台/列表展示：合并「其他」与地区拆分字段，避免 key:value 重复一行 */
export function mergeFinanceSurveyForDisplay(form) {
  const f = form || {}
  const trim = (v) => String(v || '').trim()
  return {
    survey_name: trim(f.survey_name),
    region: trim(f.region) || composeRegionText(f),
    contact_phone: trim(f.contact_phone),
    wechat_id: trim(f.wechat_id),
    douyin_nickname: trim(f.douyin_nickname),
    douyin_account_id: trim(f.douyin_account_id),
    fan_count: trim(f.fan_count),
    finance_qualifications: mergeSurveyArrayOther(
      f.finance_qualifications,
      f.finance_qualification_other,
    ),
    institution: mergeSurveySingleOther(f.institution, f.institution_other),
    work_years: trim(f.work_years),
    violation_history: mergeSurveySingleOther(f.violation_history, f.violation_history_other),
    live_platforms: mergeSurveyArrayOther(f.live_platforms, f.live_platform_other),
    live_experience: trim(f.live_experience),
    content_tracks: mergeSurveyArrayOther(f.content_tracks, f.content_track_other),
    career_motivation: trim(f.career_motivation),
    association_expectation: mergeSurveySingleOther(
      f.association_expectation,
      f.association_expectation_other,
    ),
    location_preference: trim(f.location_preference),
    honor_expectation: trim(f.honor_expectation),
    research_activity: trim(f.research_activity),
    social_voice: trim(f.social_voice),
    compliance_commitment: trim(f.compliance_commitment),
    extra_support: trim(f.extra_support),
  }
}

/** 将后端返回的问卷数据还原为前端表单结构 */
export function applyFinanceSurveyPayloadToForm(payload) {
  const base = emptyFinanceSurvey()
  if (!payload || typeof payload !== 'object') return base
  const raw =
    payload.finance_survey_form ||
    payload.finance_survey_err ||
    payload.finance_survey ||
    payload
  return snapshotFinanceSurveyForm({ ...base, ...raw })
}

/** 完整问卷快照：保留 region_codes 等 UI 字段，供后端 finance_survey_err 存储 */
export function snapshotFinanceSurveyForm(form) {
  const base = emptyFinanceSurvey()
  const f = form || {}
  return {
    ...base,
    ...f,
    region_codes: Array.isArray(f.region_codes) ? [...f.region_codes] : [],
    finance_qualifications: Array.isArray(f.finance_qualifications) ? [...f.finance_qualifications] : [],
    live_platforms: Array.isArray(f.live_platforms) ? [...f.live_platforms] : [],
    content_tracks: Array.isArray(f.content_tracks) ? [...f.content_tracks] : [],
  }
}
